export default __webpack_public_path__ + "assets/webgl/picking-17.4e9953dc.glb";